import React from 'react'
import loadable from '@loadable/component'
import CustomSliderShimmer from './CustomSliderShimmer'

const ABSwiperSlider = loadable(() => import('./ABSwiperSlider'), {
  fallback: <CustomSliderShimmer />,
})

export { ABSwiperSlider }
